import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PublicHeader, PublicFooter, ArticleCard } from '../components/PublicLayout';
import { articlesAPI, categoriesAPI } from '../lib/api';
import { useEdition } from '../lib/edition-context';
import { Skeleton } from '../components/ui/skeleton';

export default function CategoryPage() {
  const { edition } = useEdition();
  const editionParam = edition && edition !== 'global' ? edition : undefined;
  const { slug } = useParams();
  const [articles, setArticles] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    loadCategory();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, page, edition]);

  const loadCategory = async () => {
    setLoading(true);
    try {
      const catRes = await categoriesAPI.list();
      const cat = catRes.data.categories?.find(c => c.slug === slug);
      setCategory(cat);

      const artRes = await articlesAPI.list({
        category_slug: slug,
        page,
        limit: 12,
        status: 'published',
        edition: editionParam,
      });
      setArticles(artRes.data.articles || []);
      setTotalPages(artRes.data.pages || 1);
    } catch (err) {
      console.error('Failed to load category:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PublicHeader />
      <main className="bg-[#FBF7EF] min-h-screen">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 py-8">
          <div className="flex items-center gap-3 mb-8">
            {category?.color && <span className="w-1.5 h-8 rounded-full" style={{ background: category.color }} />}
            <div>
              <h1 className="news-masthead text-3xl sm:text-4xl font-bold">{category?.name || slug}</h1>
              {category?.description && <p className="text-[#5B616E] text-sm mt-1">{category.description}</p>}
            </div>
          </div>

          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1,2,3,4,5,6].map(i => <Skeleton key={i} className="h-64 rounded-xl" />)}
            </div>
          ) : articles.length > 0 ? (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {articles.map(article => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
              {totalPages > 1 && (
                <div className="flex justify-center gap-2 mt-10">
                  {Array.from({ length: totalPages }, (_, i) => (
                    <button
                      key={i}
                      onClick={() => setPage(i + 1)}
                      className={`w-10 h-10 rounded-lg text-sm font-medium transition-colors ${
                        page === i + 1 ? 'bg-[#121316] text-white' : 'bg-white border border-[#E7E0D6] hover:bg-[#E7E0D6]'
                      }`}
                    >
                      {i + 1}
                    </button>
                  ))}
                </div>
              )}
            </>
          ) : (
            <div className="bg-white rounded-xl border border-[#E7E0D6] p-12 text-center text-[#5B616E]">
              <p className="text-lg">No articles in this category yet</p>
            </div>
          )}
        </div>
      </main>
      <PublicFooter />
    </>
  );
}
